import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Link } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import axios from 'axios';
import moment from 'moment';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';
import ReactGA from "react-ga4";

function dateFormat(value, row, index) {
    console.log(value);
    return moment(value).format('MM/DD/YYYY');
}

class ViewServiceReportsRefrigerant extends React.Component {

    constructor(props) {
        super(props);
        let userExists = !(props.location.state == null || props.location.state.user == null);
        let historyExists = !(props.history.location.state == null || props.history.location.state.data == null)
        this.state = {
            user: userExists ? props.location.state.user : {},
            page: historyExists ? props.history.location.state.page : 1,
            data: historyExists ? props.history.location.state.data :  [],
            totalSize: historyExists ? props.history.location.state.totalSize :  0,
            sizePerPage: historyExists ? props.history.location.state.sizePerPage :  20,
            accounts: historyExists ? props.history.location.state.accounts :  [],
            selectedAccounts: historyExists ? props.history.location.state.selectedAccounts : [],
            buildingKey: historyExists ? props.history.location.state.buildingKey : 0,
            filterReview: historyExists ? props.history.location.state.filterReview : '',
            filterType: historyExists ? props.history.location.state.filterType : '',
            searchTerm: historyExists ? props.history.location.state.searchTerm : '',
            loading: false
        };

        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);

        this.loadingSpinner = this.loadingSpinner.bind(this);

        this.filterReview = React.createRef();
        this.filterType = React.createRef();
        this.filterText = React.createRef();
    }

    componentDidMount() {
        this.handleTableChange("search", this.state);
    }

    loadingSpinner() {
        if (this.state.loading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No records.';
        }
    };

    handleClear(event) {
        event.preventDefault();
        this.filterReview.current.value = "";
        //this.filterType.current.value = "";
        this.filterText.current.value = "";

        this.setState({
            filterReview: '',
            searchTerm: '',
            filterType: '',
            selectedAccounts: [],
            page:1
        }, function () {
            this.handleTableChange("search", this.state)
        });
    }

    handleSearch(event) {
        event.preventDefault();
        this.setState({
            page: 1
        }, this.handleTableChange("search", this.state));
    }

    handleFilterChange(event) {
        let input = this.state;
        input[event.target.name] = event.target.value;
        this.setState({
            input,
            page: 1
        }, function () {
            this.handleTableChange("search", this.state)
        });
    }

    handleSearchChange(event) {
        this.setState({
            searchTerm: event.target.value
        });
    }
    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        ReactGA.event({
            category: 'Search',
            action: 'Refrigerant Report',
            label: 'Refrigerant Report Search'
        });
        this.setState({
            loading: true,
            data:[],
            page,
            sortOrder,
            sortField,
            sizePerPage
        },
        function () {

            axios.get(`${Constants.apiURL}/api/ServiceReporting/GetServiceReports`, {
                params: {
                    user: this.state.user.username,
                    page: this.state.page,
                    pageSize: this.state.sizePerPage,
                    sortOrder: this.state.sortOrder,
                    sortField: this.state.sortField,
                    searchTerm: this.state.searchTerm,
                    filterType: this.state.filterType,
                    filterReview: this.state.filterReview,
                    isPredictive: false
                }
            }).then(response => {
                if (response.data) {

                    this.setState(() => ({
                        data: JSON.parse(response.data.data),
                        totalSize: response.data.rowcount,
                        page,
                        sortOrder,
                        sortField,
                        sizePerPage,
                        loading: false
                    }), this.getAccounts);
                }
            }).catch((response) => {
                if (response.response.status === 401) {
                    this.props.history.push({
                        pathname: '/'
                    });
                }
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
            });
        });
    }

    render() {
        const defaultSorted = [{
            dataField: 'CreatedDate',
            order: 'desc'
        }];
        const columns = [
            {
                text: '',
                dataField: 'x',
                formatter: (cell, row) => {
                    return <Button style={{ backgroundColor: '#1F419B', width: '100%' }} onClick={(event) => {
                        ReactGA.event('file_download',{
                            category: "file_download",
                            action: "file_download",
                            label: "refrigerantReport", // optional
                            value: 99, // optional, must be a number
                        });
                        axios.get(`${Constants.apiURL}/api/Guest/DownloadFile`, {
                            params: {
                                user: this.state.user.username,
                                id: row.DocLinkID
                            },
                            responseType: "blob"
                        }).then(response => {
                            this.setState({ loading: false });
                            ReactGA.event({
                                category: 'Download',
                                action: 'Refrigerant Report',
                                label: ''
                            });

                            let blob = new Blob([response.data], { type: "application/pdf" }),
                                downloadUrl = window.URL.createObjectURL(blob),
                                filename = "",
                                disposition = response.headers["content-disposition"];

                            if (disposition && disposition.indexOf("attachment") !== -1) {
                                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                                    matches = filenameRegex.exec(disposition);

                                if (matches != null && matches[1]) {
                                    filename = matches[1].replace(/['"]/g, "");
                                }
                            }
                            else {
                                alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                                return;
                            }

                            let a = document.createElement("a");
                            if (typeof a.download === "undefined") {
                                window.location.href = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename;
                                document.body.appendChild(a);
                                a.click();
                            }
                        }).catch((response) => {
                            // ? Show to user that request is failed
                            this.setState({ errors: [response] })
                            this.setState({ loading: false });
                            console.log('request failed', response)
                        });
                    }}>Download</Button>
                },
                headerStyle: (colum, colIndex) => {
                    return { width: '130px', textAlign: 'center' };
                }
            },
            {
                text: 'Date Uploaded',
                dataField: 'CreateDate',
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '130px', textAlign: 'center' };
                }
            },
            {
                text: 'Building',
                dataField: 'BuildingName',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center' };
                }
            },
            {
                text: 'Service Call ID',
                dataField: 'ServiceCallID',
                headerStyle: (colum, colIndex) => {
                    return { width: '200px', textAlign: 'center' };
                },
                formatExtraData: this.state,
                formatter: (cell, row, props, p) => {
                    console.log(row.Order);
                    return <Link to={{
                        pathname: 'view_order_details',
                        state: {
                            user: p.user,
                            input: row.Order
                        }
                    }}> {cell} </Link>
                }
            },
            {
                text: 'Equipment Serial Number(s)',
                dataField: 'MachineSerials',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', width:'300px' };
                },
                formatter: (cell, row) => {
                    let machines = cell.split(',');
                    return machines.map((item) => {
                        return <div>
                            <span>{item}</span><br />
                        </div>;
                    });
                }
            },
            {
                text: 'Report Findings?',
                dataField: 'ReviewRequired',
                headerStyle: (colum, colIndex) => {
                    return { width: '160px', textAlign: 'center', wordBreak: 'break-all' };
                },
                style: (cell, row, rowIndex, colIndex) => {
                    return { wordBreak: 'break-all' };
                },
                formatter: (cell, row) => {
                    return cell ? "Yes" : "No";
                }
            }];
        const { data, sizePerPage, page, totalSize } = this.state;
        const customStyle = {
            padding: '10px',
            margin: '10px',
            maxWidth: '480px'
        };
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='refrigerantReporting' />
                <Form onSubmit={this.handleSearch} className="mb-3 service-reporting">

                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 10px 0px 10px', justifyContent: 'right' }}>
                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', flex:1  }}>Refrigerant Reports</Form.Label><br/>
                            <Form.Label style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', paddingTop: '0px', fontStyle: 'italic', fontSize: '15px', marginBottom: '10px', flex: 1 }}>
                                Below is a list of refrigerant reports completed by technicians. Please note that reports completed prior to October 2022 may not be available online.</Form.Label>

                        </Col>
                        <Col width="100%" className="filler-col" />
                        <Row>
                            <Col width="100%" className="filler-col" />
                        <Col md="auto">
                            <Form.Select ref={this.filterReview} value={this.state.filterReview} onChange={this.handleFilterChange} placeholder="Filter by report findings" size="sm" name="filterReview" style={{ width: "200px" }}>
                                <option key='blankChoice' hidden value="">Filter by report findings</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </Form.Select>
                        </Col>
                        <Col md="auto" >
                            <Form.Control style={{ width: '320px' }} ref={this.filterText} type="input" size="sm" value={this.state.searchTerm}  onChange={this.handleSearchChange} placeholder="Search by building, service call ID, serial #..." />
                        </Col>
                        <Col md="auto" sm="auto" xs="auto" style={{paddingLeft:0}}>
                            <Button style={{ backgroundColor: '#1F419B' }} type="submit" size="sm">
                                Search
                            </Button>
                        </Col>
                        <Col md="auto" sm="auto" xs="auto" style={{ paddingLeft: 0 }}>
                            <Button size="sm" onClick={this.handleClear} variant="secondary" >
                                Clear
                            </Button>
                        </Col>
                        </Row>
                    </Form.Group>
                </Form>
                <BootstrapTable
                    bootstrap4
                    remote
                    keyField="DocumentID"
                    wrapperClasses="table-responsive refrigerant-table"
                    data={data}
                    columns={columns}
                    defaultSorted={defaultSorted}
                    //filter={filterFactory()}
                    pagination={paginationFactory({ page, sizePerPage, totalSize })}
                    striped
                    hover
                    noDataIndication={this.loadingSpinner}
                    loading={this.state.loading}
                    style={customStyle}
                    totalSize={this.state.totalSize}
                    onTableChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default ViewServiceReportsRefrigerant;